import React from "react";

export const LogisticsHub = [
  <>
    <div className="slideContainer slide_solidColour">
      <div className="colLeft col30">
      <h4 class="slideTitle mb-1">Mooi begin van het nieuwe jaar!</h4>
        <p>
          Sinds vorige week staat er een spiksplinternieuw
          publiek Shell snellaadstation op het terrein van Stadslogistiek Den
          Haag.Zo kunnen onze elektrische vrachtwagens razendsnel laden en
          bovendien worden de ruimte én de stroomaansluiting optimaal benut door
          gebruik te maken van een publiek laadstation.
        </p>
      </div>
      <div className="colRight col70">
        <img
          src="images/logiticsHub-success.jpg"
          width="100%"
          height="auto"
          alt=""
        />
      </div>
    </div>
  </>,
];
